export const mockCoachSignals = {
  status: 'ready',
  generated_at: '2026-09-07T18:00:00.000Z',
  roster: {
    authorized_athlete_count: 8,
    viewable_athlete_count: 8,
    recordable_athlete_count: 6,
    verifiable_athlete_count: 5,
    sport_scope_count: 1,
  },
  group_capture: {
    captures_last_28_days: 5,
    active_capture_count: 1,
    completed_capture_count: 4,
    athlete_slots_last_28_days: 22,
    completed_slots_last_28_days: 18,
    slot_completion_pct: 82,
    latest: {
      id: 'demo-group-capture-5',
      sport_key: 'basketball',
      sport_name: 'Basketball',
      session_type: 'assessment',
      label: 'Evening burst / brake group',
      status: 'active',
      athlete_count: 4,
      completed_count: 2,
      started_at: '2026-09-07T17:35:00.000Z',
      ended_at: null,
      created_at: '2026-09-07T17:30:00.000Z',
    },
  },
  verification: {
    awaiting_review_count: 4,
    decisions_last_28_days: 11,
    verified_last_28_days: 8,
    retest_requested_last_28_days: 2,
  },
  evidence: {
    completed_sessions_last_7_days: 9,
    completed_sessions_last_28_days: 26,
    athletes_with_completed_evidence_last_28_days: 7,
  },
}
